import React from "react";
//#region types
import { MoreActionMenuItemType } from "models/propTypes/menuPropTypes";
import { GenericDocumentTodoMoreActionProps } from "models/propTypes/documentPropTypes";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import { MoreActions, useCheckRelations } from "components/common";
import useGenericDocumentDownload from "../forms/useDownload";
import useGenericDocumentSentBackSnoozeAction from "./actions/useGenericDocumentSentBackSnoozeAction";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const GenericDocumentTodoMoreActions: React.FC<GenericDocumentTodoMoreActionProps> = (props) => {
  const { getIsReadonlyUser } = useCheckRelations();

  //#region snooze
  const snoozeAction = useGenericDocumentSentBackSnoozeAction(props.genericDocument.id, props.markAsDoneHandler);
  //#endregion

  //#region download
  const onDownloadClick = useGenericDocumentDownload(props.genericDocument.id);

  const downloadAction: MoreActionMenuItemType = {
    description: `${LocalizationHelperInstance.getFormattedMessage(
      TranslationKeys.Common.Download
    )} ${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Document.Document)}`,
    icon: IconDefinitionConstants.WDownload,
    onClickHandler: onDownloadClick,
  };
  //#endregion

  const getMenuItems = (): MoreActionMenuItemType[] => {
    const actions: MoreActionMenuItemType[] = [];
    const isReadonlyUser = getIsReadonlyUser();

    if (!isReadonlyUser) {
      actions.push(snoozeAction);
    }
    actions.push(downloadAction);

    return actions;
  };

  return <MoreActions menuItems={getMenuItems()} disableSuccessMessages={props.disableSuccessMessages} />;
};

export default GenericDocumentTodoMoreActions;
